import { Flex, Spinner } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useParams ,useLocation} from "react-router-dom";
import { Shippment } from "../../../shared";
import { getShippByIdRequest, getShippByIdResponse } from "../../../shared/src/api";
import CreateShippCard from "../components/create_shipp_card";
import UpdateShippCard from "../components/update_shipp_card";
import { ENDPOINT_CONFIGS, withParams } from "../endpoints";
import { ApiError, callEndpoint } from "../fetch";

export const CreateShipp = () =>{
  


    return (
     
      <div>
        <CreateShippCard editMode={false} shipp={null}/>
      </div>
    );
  }

  export const EditShipp = () =>{
    const location = useLocation();



      return (
      
        <div>
          <CreateShippCard editMode={true} shipp={location.state.shipp}/>
        </div>
      );
  }

  export const UpdateShipp = () =>{
    const {id:shippId}=useParams();
const [shipp, setShipp]= useState({} as Shippment)
const [busy, setBusy] = useState(true);
const [error, setError] = useState('');
  

   useEffect(()=>{

  
    const fetchData = async()=>{
    try{
      const res= await callEndpoint<getShippByIdRequest, getShippByIdResponse>(withParams(ENDPOINT_CONFIGS.getShipp, shippId!));
       
        setShipp(res.shipp);
        setBusy(false);
      } catch (e) {
        setError((e as ApiError).message);     
        setBusy(false);
      }
    }
    fetchData();
    
    },[])

   if(busy){
    return(
      <div>
         <Flex minH={'100px'} margin={'auto'} align={'center'} justify={'center'} >
        <Spinner></Spinner>
        </Flex>
      </div>
    )
  }
  
if (error){
return(

  <Flex minH={'100px'} margin={'auto'} align={'center'} justify={'center'} >
 {error}
 </Flex>
);}
   
      


    return ( 
      <div>
        <UpdateShippCard  shipp={shipp} />
      </div>
    );
  }